<script lang="ts">
  import Loader from '$shared/atoms/Loader/Loader.svelte';
  import Card from '$shared/atoms/Card/Card.svelte';
  import screenshotService from '$shared/services/screenshotService';
  import Preview from './partials/Preview.svelte';
  import { ScreenshotType } from '$shared/constants/ScreenshotType';

  interface Props {
    list?: string[];
    type?: ScreenshotType;
    onpreview?: (url: string) => void;
  }

  let { list = [], type = ScreenshotType.Preview, onpreview }: Props = $props();
</script>

<div class="comp-screenshots">
  {#if Array.isArray(list) && list.length > 0}
    {#await screenshotService.getAllScreenshotAsync(list)}
      <div class="loading">
        <Card>
          <Loader count={3} />
        </Card>
      </div>
    {:then dataUrls}
      {#if type === ScreenshotType.Enlarge}
        <div class="list-screenshot">
          {#each dataUrls as url}
            <img class="screenshot" src={url} alt="Screenshot" />
          {/each}
        </div>
      {:else}
        <Preview screenshotUrls={dataUrls} {onpreview} />
      {/if}
    {:catch _}
      <img src="" alt="failed to load" />
    {/await}
  {/if}
</div>

<style>
  .comp-screenshots {
    width: 100%;
  }
  .list-screenshot img {
    width: 100%;
  }
</style>
